import { StyleSheet } from 'react-native';
export var getDynamicScrollListWidgetStyles = (props, flatListWidth) => {
  var _props$separatorSpace = props.separatorSpace,
    separatorSpace = _props$separatorSpace === void 0 ? 2 : _props$separatorSpace,
    _props$seekGap = props.seekGap,
    seekGap = _props$seekGap === void 0 ? 0 : _props$seekGap,
    _props$numberOfColumn = props.numberOfColumn,
    numberOfColumn = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    _props$startEndSeekGa = props.startEndSeekGap,
    startEndSeekGap = _props$startEndSeekGa === void 0 ? 0 : _props$startEndSeekGa;
  var width = flatListWidth / numberOfColumn - separatorSpace - (seekGap + startEndSeekGap) / numberOfColumn;
  return StyleSheet.create({
    contentContainer: Object.assign({}, !!seekGap && {
      paddingHorizontal: startEndSeekGap
    }),
    singleListItemWidth: {
      width: width
    },
    listContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row'
    }
  });
};